module.exports = __webpack_public_path__ + "media/assets/fonts/NeueHaasGrotesk-Bold-bd0789975a9335536bb2e85fa862d184.ttf";